import i18n from 'i18next';
import { rotuloFormaPagamento } from '@malgoos/shared';

/**
 * Review r37 spec (B1): o nome da forma de pagamento é gravado em português (tipo + abreviatura, a chave da unicidade);
 * a tela mostra o rótulo do tipo no idioma de quem vê ("Bank transfer Itaú"). Com tipo e abreviatura (catálogo), confere
 * que o nome é o derivado; só com o nome (`forma_pagamento_nome` de documentos, compras e lançamentos), traduz o começo.
 */
export function rotuloForma(f: { nome: string | null | undefined; tipo?: string | null; abreviatura?: string | null }): string {
  return rotuloFormaPagamento(f, (i18n.resolvedLanguage ?? i18n.language ?? 'pt').slice(0, 2));
}

/** Atalho para o `forma_pagamento_nome` que chega pronto nas outras telas. */
export const rotuloNomeForma = (nome: string | null | undefined) => rotuloForma({ nome });
